module.exports = __webpack_public_path__ + "static/doctor-01a8ed09f6bd3c56f89ede52d0e5c78e.svg";